<template>
	<div class="tw-flex">
		<input type="checkbox" :id="name" :checked="value" @input="$emit('input', $event.target.checked, name)">
		<label class="tw-font-medium" :for="name">{{ label }}</label>
	</div>
</template>

<script>
export default {
	name: 'FormCheckbox',

	props: ['label','value', 'name'],
}
</script>

<style lang="scss" scoped>
input[type=checkbox] {
	@apply tw-inline-block tw-w-auto tw-mr-4;
}
</style>
